import type { ReactNode } from "react";
import { useInView } from "react-intersection-observer";
import TitleBarOuter from "./TitleBarOuter";
import type { TitleBarOuterProps } from "./TitleBarOuter";

interface TitleBarScrollObsOuterProps {
  breakpointDisplay?: TitleBarOuterProps["breakpointDisplay"];
  leadingNode?: ReactNode;
  trailingNode?: ReactNode;
  initialContentNode?: ReactNode;
  scrolledContentNode?: ReactNode;
}

const TitleBarScrollObsOuter = ({
  breakpointDisplay,
  leadingNode = null,
  trailingNode = null,
  initialContentNode = null,
  scrolledContentNode = null,
}: TitleBarScrollObsOuterProps) => {
  const { ref: titleRef, inView: titleInView } = useInView({
    initialInView: true,
    rootMargin: "0px 0px 0px 0px",
  });

  let displayCss = "";
  if (breakpointDisplay) {
    if (breakpointDisplay === "SHOW_LG_UP") {
      displayCss = `hidden lg:block`;
    } else if (breakpointDisplay === "HIDE_LG_UP") {
      displayCss = `lg:hidden`;
    }
  }

  return (
    <>
      <TitleBarOuter breakpointDisplay={breakpointDisplay} bordered={!titleInView}>
        <>
          {leadingNode}
          <div className={`flex-1 truncate`}>
            {titleInView ? initialContentNode : scrolledContentNode}
          </div>
          {trailingNode}
        </>
      </TitleBarOuter>
      {scrolledContentNode && (
        <div className={`h-0 ${displayCss}`} ref={titleRef} aria-hidden="true" />
      )}
    </>
  );
};

export default TitleBarScrollObsOuter;
